import { getUserSession } from "./Common/lib/Session";
import { useEffect } from "react";
import { useHistory, } from "react-router-dom";

function Protected(props) {
  const history = useHistory();

  useEffect(() => {
    getUserSession().then((res) => {
      if (res.success) {
        if (props.path.includes("admin") && !res.is_staff) {
          history.replace("/404");
        }

        if (props.path.includes("contributions") && !res.is_staff) {
          history.replace("/");
        }

        return <>{props.children}</>;
      } else {
        history.replace("/");
      }
    }).catch((err) => {
      history.replace("/");
    });
  });

  return <>{props.children}</>;
}

export default Protected;